// extracted by mini-css-extract-plugin
export default {"cartIcon":"CartIcon_cartIcon__RX67Q","icon":"CartIcon_icon__nkbAv","badge":"CartIcon_badge__iJ3tz"};